<template>
    <div class="panel panel-default panel-dashboard">
        <div v-if="!loading" class="panel-body">
            <form @submit.prevent="submit" style="margin-bottom: 22px">
                <div class="row">
                    <div class="col-sm-12">
                        <input
                            type="search"
                            v-model="actualListFilters.search"
                            class="form-control"
                            placeholder="Search..."
                        >
                    </div>

                    <div class="col-sm-6">
                        <select-widget
                            v-model="actualListFilters.status"
                            :nullable="true"
                            :options="[{value: 'booked', label: 'Booked'}, {value: 'held', label: 'Held'}]"
                            placeholder="(all statuses)"
                        />
                    </div>

                    <div class="col-sm-6">
                        <button type="submit" class="btn btn-grey btn-block">
                            <i class="fa fa-filter"></i> Filter
                        </button>
                    </div>
                </div>
            </form>

            <table class="table table-striped table-condensed">
                <thead>
                <tr>
                    <th class="col-xs-1 text-center">
                        <input
                            type="checkbox"
                            v-model="selectAll"
                            :indeterminate.prop="selected.length && selected.length !== meetings.length"
                        >
                    </th>

                    <th class="col-xs-4">
                        Company
                    </th>

                    <th class="col-xs-4">
                        User
                    </th>

                    <th class="col-xs-3">
                        <a href="#" @click.prevent="sort('created_at')">
                            Created At <i class="fa fa-sort"></i>
                        </a>
                    </th>

                    <th class="col-xs-4">
                        <a href="#" @click.prevent="sort('starts_at')">
                            Date <i class="fa fa-sort"></i>
                        </a>
                    </th>

                    <th class="col-xs-4">
                        Attributes
                    </th>

                    <th class="col-xs-3">
                        Status
                    </th>

                    <th class="col-xs-1"></th>
                </tr>
                </thead>

                <tbody>
                <tr v-for="meeting in meetings">
                    <td class="text-center">
                        <input
                            type="checkbox"
                            v-model="selected"
                            :value="meeting"
                        >
                    </td>

                    <td class="table__ellipsis">
                        <router-link :to="'/companies/' + meeting.attributes.company_id">
                            {{ meeting.attributes.company_name }}
                        </router-link>
                    </td>

                    <td>
                        <router-link :to="'/users/' + meeting.attributes.user_id + '/edit'">
                            {{ meeting.attributes.user_full_name }}
                        </router-link>
                    </td>

                    <td>
                        {{ meeting.attributes.created_at | date }}
                    </td>

                    <td>
                        {{ meeting.attributes.starts_at | datetime }} - {{ meeting.attributes.ends_at | time }}
                    </td>

                    <td>
                        <span v-if="meeting.attributes.category === 'online'" class="label label-warning">Online</span>

                        <span v-if="meeting.attributes.category === 'physical'"
                              class="label label-success">Physical</span>

                        <span v-if="meeting.attributes.is_new_business" class="label label-success">New</span>

                        <span v-else class="label label-warning">Existing</span>
                    </td>

                    <td>
                        <span v-if="meeting.attributes.has_sale" class="label"
                              style="background-color: #62d26f">Sale</span>

                        <span v-else-if="meeting.attributes.has_opportunity" class="label"
                              style="background-color: #eec300">Opportunity</span>

                        <span v-else-if="meeting.attributes.held_at" class="label" style="background-color: #e8384f">Held</span>

                        <span v-else class="label" style="background-color: #fd9a00">Booked</span>
                    </td>

                    <td class="text-right">
                        <div class="btn-group list-actions">
                            <button
                                type="button"
                                class="btn btn-sm"
                                :disabled="true"
                            >
                                <i class="fa fa-search"></i>
                            </button>

                            <button
                                type="button"
                                class="btn btn-sm"
                                :disabled="true"
                            >
                                <i class="fa fa-trash"></i>
                            </button>
                        </div>
                    </td>
                </tr>
                </tbody>
            </table>

            <div class="row">
                <div class="col-xs-6">
                    <div class="dropup">
                        <button
                            class="btn btn-info btn-sm dropdown-toggle"
                            type="button"
                            data-toggle="dropdown"
                            :disabled="!selected.length"
                        >
                            <i class="fa fa-cogs"></i> List Actions <span class="caret"></span>
                        </button>

                        <ul class="dropdown-menu">
                            <li>
                                <a href="#" @click.prevent="holdSelected()">
                                    <i class="fa fa-check"/> Mark selected as held
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>

                <div class="col-xs-12">
                    <resource-pager
                        class="table__pager"
                        v-if="pagination.last_page > 1"
                        :pagination="pagination"
                        @navigate="$emit('navigate', page = $event)"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import http from '@/http'
import modal from '@/modal'
import notify from '@/notify'
import ResourcePager from '@/components/Utilities/Pagination/ResourcePager'
import SelectWidget from '@/vendor/forms/FormGroups/Widgets/Select'

export default {
    components: {ResourcePager, SelectWidget},

    props: {
        filters: {
            required: true,
            type: Object
        }
    },

    data() {
        return {
            meetings: [],
            pagination: null,

            listFilters: {},
            actualListFilters: {},

            sortColumn: 'starts_at',
            sortDirection: 'asc',

            editing: null,

            loading: true,
            selected: [],
            selectAll: false,
            page: 1
        }
    },

    mounted() {
        this.load()
    },

    watch: {
        page() {
            this.load()
        },

        filters: {
            deep: true,
            handler: function () {
                this.navigate(1)
            }
        },

        selected() {
            if (this.selected.length === this.meetings.length) {
                this.selectAll = true
            }

            if (this.selected.length === 0) {
                this.selectAll = false
            }
        },

        selectAll(value) {
            this.selected = value ? this.meetings : []
        }
    },

    computed: {
        requestParameters() {
            let parameters = Object.entries(this.filters)
                .concat(Object.entries(this.listFilters))
                .reduce((filters, filter) => {
                    if (!filter[1]) {
                        return filters
                    }

                    filters['filter[' + filter[0] + ']'] = filter[1]

                    return filters
                }, {})

            parameters.page_size = 10

            parameters.page = this.page

            parameters.sort = this.sortColumn ? (this.sortDirection === 'desc' ? '-' : '') + this.sortColumn : null

            return parameters
        }
    },

    methods: {
        load() {
            this.selected = []

            http.get('/api/v2/meetings', this.requestParameters).then(response => {
                this.meetings = response.data.data

                this.pagination = response.data.meta

                this.loading = false
            })
        },

        edit(meeting) {
            this.editing = meeting

            $('#edit-meeting-modal').modal('show')
        },

        destroy(meeting) {
            modal.confirm('Are you sure that you want to delete the meeting?', () => {
                this.getDestroyPromise(meeting).then(() => {
                    notify.success('The meeting was deleted')

                    this.load()
                })
            })
        },

        destroySelected() {
            modal.confirm('Are you sure that you want to delete the meetings?', () => {
                Promise.all(this.selected.map(meeting => this.getDestroyPromise(meeting))).then(() => {
                    notify.success('The meetings were deleted')

                    this.load()
                })
            })
        },

        holdSelected() {
            modal.confirm('Are you sure that you want to mark the meetings as held?', () => {
                Promise.all(
                    this.selected.map(selected => http.post('/api/v2/held-meetings', {meeting_id: selected.id})
                        .then(response => {
                            this.update(response.data.data)
                        })
                        .catch(() => {
                        })
                    )
                ).then(() => {
                    notify.success('The meetings were marked as held')

                    this.selected = []
                })
            })
        },

        getDestroyPromise(meeting) {
            return http.delete('/api/v2/meetings/' + meeting.id)
        },

        update(meeting) {
            let index = this.meetings.findIndex(existing => existing.id === meeting.id)

            if (index > -1) {
                this.meetings.splice(index, 1, meeting)
            }
        },

        sort(column) {
            if (this.sortColumn === column) {
                this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc'
            } else {
                this.sortDirection = 'desc'
            }

            this.sortColumn = column

            this.navigate(1)
        },

        navigate(page) {
            this.page = page

            this.load()
        },

        submit() {
            this.listFilters = this.actualListFilters

            this.navigate(1)
        }
    }
}
</script>
